import React from 'react';
import { Layout as AntLayout } from 'antd';
import Navbar from '../Navbar/Navbar.jsx';
import './Layout.css';

const { Content } = AntLayout;

const Layout = ({ children, showMenu = true }) => {
  return (
    <AntLayout className="main-layout">
      <Navbar menu={showMenu} />
      <Content className="main-content">
        {children}
      </Content>
    </AntLayout>
  );
};

export default Layout; 